// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import { initializeApp } from 'firebase/app';

// Setting up cloud function call
// import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';
import { getFirestore } from 'firebase/firestore/lite';

const { initializeAppCheck, ReCaptchaV3Provider } = require('firebase/app-check');

// CHANGE ENVIRONMENT HERE. BE VERY GODDAMN CAREFUL
// const env = 'staging';
// export const currentDomain = window.location.hostname;
export const currentDomain = document.location.hostname;

let siteKey; let
  firebaseConfig;

switch (currentDomain) {
  case 'microtone-staging.web.app':
    siteKey = '6LcOPG0cAAAAAJ_1HLVNIgc3QK8w4A-NCitdCtYq';
    firebaseConfig = {
      apiKey: 'AIzaSyAgrmW0kqHeEyP5-RxITQaOWi-4h0rnGKw',
      authDomain: 'microtone-staging.firebaseapp.com',
      projectId: 'microtone-staging',
      storageBucket: 'microtone-staging.appspot.com',
      messagingSenderId: '718987707661',
      appId: '1:718987707661:web:070aabda729845fd0a9c44',
    };
    break;

  case 'www.microtoneguitars.com':
    siteKey = '6LcAoHQcAAAAAM73-NuWCFwrg5A6sezEVJIXyeTo';
    firebaseConfig = {
      apiKey: 'AIzaSyCnmpmwpVU7PiM7PHRvkMGUa944o2OVJc4',
      authDomain: 'microtone-landing-prod.firebaseapp.com',
      projectId: 'microtone-landing-prod',
      storageBucket: 'microtone-landing-prod.appspot.com',
      messagingSenderId: '1011373261630',
      appId: '1:1011373261630:web:4d6de583b50ef8d3f8e26f',
    };
    break;

  default:
    // siteKey = '6LcOPG0cAAAAAJ_1HLVNIgc3QK8w4A-NCitdCtYq';
    firebaseConfig = {
      apiKey: 'AIzaSyCvXLVNfHxAqlSOx8VL0UIiXKWIGS9Ge5U',
      authDomain: 'microtone-prototype.firebaseapp.com',
      databaseURL: 'https://microtone-prototype.firebaseio.com',
      projectId: 'microtone-prototype',
      storageBucket: 'microtone-prototype.appspot.com',
      messagingSenderId: '378899631606',
      appId: '1:378899631606:web:5ad53d902c11fc4f74cbd7',
      measurementId: 'G-0MSMXCYHM8',
    };
    break;
}

// Prototype config
// const firebaseConfig = {
//   apiKey: 'AIzaSyCvXLVNfHxAqlSOx8VL0UIiXKWIGS9Ge5U',
//   authDomain: 'microtone-prototype.firebaseapp.com',
//   databaseURL: 'https://microtone-prototype.firebaseio.com',
//   projectId: 'microtone-prototype',
//   storageBucket: 'microtone-prototype.appspot.com',
//   messagingSenderId: '378899631606',
//   appId: '1:378899631606:web:5ad53d902c11fc4f74cbd7',
//   measurementId: 'G-0MSMXCYHM8',
// };

// Staging config
// const firebaseConfig = {
//   apiKey: 'AIzaSyAgrmW0kqHeEyP5-RxITQaOWi-4h0rnGKw',
//   authDomain: 'microtone-staging.firebaseapp.com',
//   projectId: 'microtone-staging',
//   storageBucket: 'microtone-staging.appspot.com',
//   messagingSenderId: '718987707661',
//   appId: '1:718987707661:web:070aabda729845fd0a9c44',
// };

// Prod config
// const firebaseConfig = {
//   apiKey: 'AIzaSyCnmpmwpVU7PiM7PHRvkMGUa944o2OVJc4',
//   authDomain: 'microtone-landing-prod.firebaseapp.com',
//   projectId: 'microtone-landing-prod',
//   storageBucket: 'microtone-landing-prod.appspot.com',
//   messagingSenderId: '1011373261630',
//   appId: '1:1011373261630:web:4d6de583b50ef8d3f8e26f',
// };


export const app = initializeApp(firebaseConfig);
// const functions = getFunctions(app);

// const siteKeyStaging = '6LcOPG0cAAAAAJ_1HLVNIgc3QK8w4A-NCitdCtYq';
// const siteKeyProd = '6LcAoHQcAAAAAM73-NuWCFwrg5A6sezEVJIXyeTo';
export const appCheck = initializeAppCheck(app, {
  // Staging site
  provider: new ReCaptchaV3Provider(siteKey),

  // Prod site
  // provider: new ReCaptchaV3Provider(siteKeyProd),

  // Optional argument. If true, the SDK automatically refreshes App Check
  // tokens as needed.
  isTokenAutoRefreshEnabled: true,
});

// appCheck().setTokenAutoRefreshEnabled(true);

export const functions = getFunctions(app);

export const firestore = getFirestore(app);


// export default app;
// export default functions;
